import React from 'react';
import styled from 'styled-components';
import {Select} from 'antd';
import {navigate} from 'gatsby';
import {useOutlet} from 'reconnect.js';
import {Facebook} from '@styled-icons/boxicons-logos';
import * as AppActions from '../../AppActions';
import TermsDialog from '../TermsDialog';

const L = AppActions.L;
const F = AppActions.F;

function SiteFooter() {
  const [navbarConfig] = useOutlet('navbarConfig');
  const [locale, setLocale] = useOutlet('locale');
  const [dimension] = useOutlet('dimension');
  const [openDialog, setOpenDialog] = React.useState(false);

  return (
    <>
      {/* <div style={{width: '100%', padding: 10}}>
        <Select
          value={locale.lang}
          onChange={(nextLang) => setLocale({lang: nextLang})}
          style={{width: 100}}>
          <Select.Option value="tw">中文</Select.Option>
          <Select.Option value="en">English</Select.Option>
        </Select>
      </div> */}
      <Wrapper isMobile={!(dimension.rwd === 'desktop')}>
        <div
          className="content-section"
          style={{
            padding: 30,
            flexDirection: dimension.rwd === 'desktop' ? 'row' : 'column',
          }}>
          <div className="constrain">
            <h2
              onClick={() => navigate('/')}
              style={{flex: 1, cursor: 'pointer'}}>
              <img
                src="/images/FooterLogo.png"
                alt="Logo"
                style={{
                  height: dimension.rwd === 'desktop' ? 140 : 100,
                  objectFit: 'contain',
                }}
              />
            </h2>
            <div className="row">
              <div className="info">
                <div className="link-item" onClick={() => navigate(it.path)}>
                  {L('landing')}
                </div>
                {navbarConfig &&
                  Array.isArray(navbarConfig.entries) &&
                  navbarConfig.entries.length > 0 &&
                  navbarConfig.entries.slice(0, 3).map((it, idx) => {
                    return (
                      <div
                        className="link-item"
                        onClick={() => navigate(it.path)}>
                        {F(it, 'name')}
                      </div>
                    );
                  })}
              </div>

              <div className="info">
                {navbarConfig &&
                  Array.isArray(navbarConfig.entries) &&
                  navbarConfig.entries.length > 0 &&
                  navbarConfig.entries.slice(3, 7).map((it, idx) => {
                    return (
                      <div
                        className="link-item"
                        onClick={() => navigate(it.path)}>
                        {F(it, 'name')}
                      </div>
                    );
                  })}
              </div>
            </div>

            <div
              className="info"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignSelf: 'stretch',
              }}>
              <a
                style={{color: '#434343'}}
                href="https://www.facebook.com/vbeautyTC"
                target="_blank"
                rel="noreferrer">
                <div className="link-item">
                  <Facebook
                    size={20}
                    style={{marginRight: 10, color: '#b02b4c'}}
                  />
                  {`${L('clinic_taichung')}     04 2328 8880`}
                </div>
              </a>
              <a
                style={{color: '#434343'}}
                href="https://www.facebook.com/vbclinic"
                target="_blank"
                rel="noreferrer">
                <div className="link-item">
                  <Facebook
                    size={20}
                    style={{marginRight: 10, color: '#b02b4c'}}
                  />
                  {`${L('clinic_taipei')}     02 2721 9663`}
                </div>
              </a>
              <div style={{flex: 1}} />
              <div
                style={{
                  maxWidth: 280,
                  justifyContent:
                    dimension.rwd === 'desktop' ? 'flex-end' : 'center',
                  textAlign: 'right',
                }}>
                <a
                  href="https://www.youtube.com/channel/UCXfn2Ob1iDzajn-ZzT0sEmw"
                  target="_blank"
                  rel="noreferrer">
                  <img
                    src="/images/youtube.png"
                    alt="Logo"
                    style={{height: 40, objectFit: 'contain'}}
                  />
                </a>
                <a
                  href="https://www.instagram.com/vbeauty.group/"
                  target="_blank"
                  rel="noreferrer">
                  <img
                    src="/images/ig.png"
                    alt="Logo"
                    style={{height: 33, objectFit: 'contain', marginLeft: 15}}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-section">
          <div className="constrain" style={{color: '#979797'}}>
            <p>
              {L('footer_statement_text')}
              <div style={{display: 'inline'}}>
                © {new Date().getFullYear()} V.Beauty Plastic Clinic all rights
                reserved.
              </div>
              <p
                onClick={() => setOpenDialog(true)}
                style={{
                  display: 'inline',
                  borderBottom: `1px solid #979797`,
                  paddingBottom: 2,
                  marginLeft: 20,
                  cursor: 'pointer',
                }}>
                {L('footer_contract_name')}
              </p>
            </p>
          </div>
        </div>
      </Wrapper>
      <TermsDialog show={openDialog} closeDialog={() => setOpenDialog(false)} />
    </>
  );
}

const Wrapper = styled.div`
  display: flex;
  background-color: white;
  flex-direction: column;
  width: 100vw;

  & .constrain {
    margin: 0 auto;
    max-width: 1024px; //var(--contentMaxWith);
    display: flex;
    flex: 1;
    flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};
    align-items: center;
  }

  & > .bottom-section {
    background-color: #f6f6f6;
    padding: 25px 40px;
    font-size: 13px;
  }

  & > .content-section {
    display: flex;

    & .info {
      flex-basis: 100px;
      & img {
        cursor: pointer;
      }
    }
    & .link-item {
      min-width: 150px;
      padding: 10px 0px;
      cursor: pointer;
      transition: all 0.2s ease-out;
      white-space: nowrap;
      text-align: ${(props) => (props.isMobile ? 'center' : 'left')};
      color: #434343;

      :hover {
        color: #797979;
      }
    }

    & .social-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 35px;
      height: 35px;
      border: 1px solid #eee;
      border-radius: 20px;
    }
  }
`;

export default SiteFooter;
